<!--
appプロパティ
  v-mainの外に配置してApplication構造の一部とする場合はtrueを、内部（Dialog等）で利用する場合はfalseを指定する
-->
<template>
  <div>
    <!-- appでない場合はコンテンツがbarの下に潜り込んでしまうので、それを避けるdivをbarと同じ高さ分用意する -->
    <div
      v-if="!app"
      :style="`height:${STYLES.APP_BAR_HEIGHT}px`"
    />
    <v-app-bar
      :app="app"
      :style="isModal ? { position: 'fixed', top: '0px', left: '0px', width: '100%' } : {position: 'fixed'}"
      color="#ffffff"
      :height="STYLES.APP_BAR_HEIGHT"
      :extension-height="STYLES.APP_BAR_EXTENSION_HEIGHT"
      class="sm__app-bar"
    >
      <template #prepend>
        <v-app-bar-nav-icon
          v-if="leftIcon"
          @click="onClickLeftIcon()"
          ref="leftVIconRef"
          :icon="leftIcon"
          density="compact"
        />
      </template>

      <v-app-bar-title class="mr-4">
        <sm-text
          format="sm__title"
          style="white-space: nowrap;"
          :text="label"
          class="sm__app-bar-label"
        />
      </v-app-bar-title>

      <template v-if="iconVisible">
        <!-- v-iconのみだと押下後も選択状態になるためボタンとする-->
        <v-btn
          v-if="rightThirdIcon"
          icon
          variant="text"
          @click="$emit('click-right-third-icon')"
          class="sm__app-bar-icon mr-6"
          :max-width="24"
          :max-height="24"
        >
          <v-icon>
            {{ rightThirdIcon }}
          </v-icon>
        </v-btn>

        <v-icon
          v-if="rightFirstIcon"
          @click="onClickRightFirstIcon()"
          class="sm__app-bar-icon"
          ref="rightFirstVIconRef"
        >
          {{ rightFirstIcon }}
        </v-icon>

        <sm-badge
          v-if="rightSecondIcon"
          dot
          :visible="rightSecondBadgeVisible"
          class="sm__app-bar-badge mr-4"
          @click="$emit('click-right-second-icon')"
          :icon="rightSecondIcon"
        />
      </template>

      <template
        #extension
        v-if="isExtensionVisible"
      >
        <!-- 区分所有者アプリでは長計画面のみtab構造が必要で、実装時点で汎用的な作りへの変更が難しかったため、特別に固定で埋め込んでいる -->
        <div class="d-flex justify-space-between sm__app-bar_extentions mx-4">
          <sm-tabs
            v-model="selectedTab"
            :tabs="Object.values(REPAIR_PLAN_TABS).map(e => e.name)"
          />
          <sm-btn-text
            text="更新履歴"
            class="my-auto"
            @click-btn="$emit('click-extension-btn')"
          />
        </div>
      </template>
    </v-app-bar>
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent } from 'vue'
import type { DefineComponent } from 'vue'
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { STYLES } from '@/constants/styles'
import { REPAIR_PLAN_TABS } from '@/constants/constants'

@Component({
  components: {
    SmBtnText: defineAsyncComponent(() => import('@/components/atoms/SmBtnText.vue')),
    SmText: defineAsyncComponent(() => import('@/components/atoms/SmText.vue')),

    SmBadge: defineAsyncComponent(() => import('@/components/molecules/SmBadge.vue')),
    SmTabs: defineAsyncComponent(() => import('@/components/molecules/SmTabs.vue')),
  },
  emits: ['click-right-third-icon', 'click-right-second-icon', 'click-extension-btn', 'update:modelValue', 'click-left-icon', 'click-right-first-icon']
})
export default class SmAppBar extends Vue {
  STYLES = Object.freeze(STYLES)
  REPAIR_PLAN_TABS= Object.freeze(REPAIR_PLAN_TABS)

  @Prop({ type: String, default: REPAIR_PLAN_TABS.summary.tab })
  private modelValue!: string

  private get selectedTab():string { return this.modelValue }

  private set selectedTab(newValue:string) { this.$emit('update:modelValue', newValue) }

  @Prop({ type: Boolean, default: false })
  private readonly app!: boolean

  @Prop({ type: String })
  private readonly label?: string

  @Prop({ type: String })
  private readonly sublabel?: string

  @Prop({ type: Boolean, default: false })
  private readonly iconVisible!: boolean

  @Prop({ type: String })
  private readonly leftIcon?: string

  @Prop({ type: String })
  private readonly rightFirstIcon?: string

  @Prop({ type: String })
  private readonly rightSecondIcon?: string

  @Prop({ type: String })
  private readonly rightThirdIcon?: string

  @Prop({ type: Boolean, default: false })
  private readonly rightSecondBadgeVisible!:boolean

  @Prop({ type: Boolean, default: false })
  private readonly isExtensionVisible!: boolean

  @Prop({ type: Boolean, default: false })
  private readonly isModal!: boolean

  onClickLeftIcon():void {
    const refs = this.$refs.leftVIconRef as DefineComponent
    const el = refs.$el as HTMLButtonElement
    el.blur()
    this.$emit('click-left-icon')
  }

  onClickRightFirstIcon():void {
    const refs = this.$refs.rightFirstVIconRef as DefineComponent
    const el = refs.$el as HTMLButtonElement
    el.blur()
    this.$emit('click-right-first-icon')
  }
}

</script>

<style scoped>
.sm__app-bar.sm__app-bar.sm__app-bar.sm__app-bar {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.13);
}
.sm__app-bar .sm__app-bar-icon, .sm__app-bar-badge .sm__app-bar-icon, .sm__app-bar .sm__app-bar-label {
  color: #000000;
  right: 20px;
}
.sm__app-bar .sm__app-bar-sublabel {
  color: rgba(0, 0, 0, 0.7);
}

.sm__app-bar_extentions{
  width: 100%;
}
</style>
